// 从环境变量中获取OSS域名配置
const getOssUrls = () => {
  const urls = []
  
  // 添加主图片域名
  if (process.env.VUE_APP_IMG_URL) {
    urls.push(process.env.VUE_APP_IMG_URL)
  }
  
  // 添加Logo图片域名
  if (process.env.VUE_APP_LOGO_IMG_URL) {
    urls.push(process.env.VUE_APP_LOGO_IMG_URL)
  }
  
  // 如果环境变量未配置，使用默认值
  if (urls.length === 0) {
    urls.push('https://resource.rcclchina.com.cn')
    urls.push('https://resource.rcclchina.com.cn/logo/MB')
  }
  
  return urls
}

const OSS_IMG_URL = getOssUrls()

// 获取版本号
const getVersion = () => {
  // 优先使用环境变量中的版本号
  if (process.env.VUE_APP_OSS_VERSION) {
    return process.env.VUE_APP_OSS_VERSION
  }
  
  // 在开发环境使用时间戳，在生产环境使用固定版本号
  return process.env.NODE_ENV === 'development' 
    ? new Date().getTime() 
    : '1.0.2' // OSS版本号
}

const VERSION = getVersion()

export default {
  bind(el) {
    // 存储原始URL
    el._originalSrc = el.src

    const addVersion = (url) => {
      if (!url) return url
      // 检查是否是OSS域名
      const isOssUrl = OSS_IMG_URL.some(domain => url.includes(domain))
      if (!isOssUrl) return url
      
      // 检查URL是否已经处理过
      if (url.includes(`v=${VERSION}`)) return url
      
      // 移除已存在的版本参数（如果有）
      const baseUrl = url.split('?')[0]
      const queryString = url.split('?')[1] || ''
      const params = new URLSearchParams(queryString)
      
      // 设置新的版本号
      params.set('v', VERSION)
      
      return `${baseUrl}?${params.toString()}`
    }

    const updateSrc = () => {
      const newSrc = addVersion(el.src)
      if (newSrc !== el.src) {
        el.src = newSrc
      }
    }

    const updateInlineStyle = () => {
      const style = el.style.cssText
      if (!style) return

      // 匹配内联样式中的所有URL
      const urlRegex = /url\(['"]?(.*?)['"]?\)/g
      let match
      let newStyle = style
      let hasChange = false

      while ((match = urlRegex.exec(style)) !== null) {
        const originalUrl = match[1]
        const newUrl = addVersion(originalUrl)
        if (originalUrl !== newUrl) {
          newStyle = newStyle.replace(originalUrl, newUrl)
          hasChange = true
        }
      }

      if (hasChange) {
        el.style.cssText = newStyle
      }
    }

    if (el.tagName === 'IMG') {
      // 初始化时处理一次
      if (el.src) {
        updateSrc()
      }

      // 使用defineProperty来监听src的变化
      const descriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src')
      Object.defineProperty(el, 'src', {
        get: function () {
          return descriptor.get.call(this)
        },
        set: function (value) {
          const newValue = addVersion(value)
          descriptor.set.call(this, newValue)
        },
        configurable: true
      })
    }

    // 处理内联样式
    if (el.style.cssText) {
      updateInlineStyle()
    }

    // 监听style属性变化
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && 
           (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
          updateInlineStyle()
        }
      })
    })

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['style', 'class']
    })
  },

  update() {
    // 不需要在update钩子中做任何事情，因为我们已经通过defineProperty和MutationObserver处理了变化
  },

  unbind(el) {
    // 清理工作：恢复原始的src属性
    if (el.tagName === 'IMG' && el._originalSrc) {
      Object.defineProperty(el, 'src', Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src'))
      el.src = el._originalSrc
    }
  }
}